window.Products.Clothing.ComfortTShirt = function() {
};
window.Products.Clothing.ComfortTShirt.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.ComfortTShirt.dpi = 150;
window.Products.Clothing.ComfortTShirt.has_3d = true;
window.Products.Clothing.ComfortTShirt.id = 100;
window.Products.Clothing.ComfortTShirt.slug = 'comfort-t-shirt';
window.Products.Clothing.ComfortTShirt.syncColors = true;
window.Products.Clothing.ComfortTShirt.texturesLoaded = 0;
window.Products.Clothing.ComfortTShirt.texturesLoading = false;
window.Products.Clothing.ComfortTShirt.use_glb = true;

window.Products.Clothing.ComfortTShirt.prototype.outsideObject = 0;
window.Products.Clothing.ComfortTShirt.prototype.detailsObject = 1;
window.Products.Clothing.ComfortTShirt.prototype.position = 0.1;

window.Products.Clothing.ComfortTShirt.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather") || color == "sport_grey"){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.ComfortTShirt.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"azalea": 0xe98a9d,
		"daisy": 0xfcd955,
		"dark_heather": 0x5a6062,
		"forest": 0x23372c,
		"irish_green": 0x259f62,
		"navy": 0x262840,
		"red": 0x901819,
		"royal": 0x315ad7,
		"sand": 0xd5c6af,
		"sport_grey": 0xc7c8c9,
	};

	return new THREE.Color(colors[_name]);
};